module.exports = __webpack_public_path__ + "static/media/facebook.33c2fef4.svg";